import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * Temporary launch gate: the marketing signup is dev-only until launch
 * (environment.marketingSignupEnabled). As a canMatch guard it also keeps
 * the lazy marketing chunk from ever being requested where disabled.
 */
export const marketingEnabledGuard: CanMatchFn = () => {
  return environment.marketingSignupEnabled ? true : inject(Router).createUrlTree(['/']);
};
